var map = {
	"./DMC.jpg": "81ac",
	"./DMC_DSK.jpg": "7139",
	"./ECOCASANCO.jpg": "4392",
	"./EQUIPTOP.jpg": "0407",
	"./FT.jpg": "e810",
	"./Hessapp.jpg": "0b99",
	"./IKEGAI.jpg": "a763",
	"./IMAS.jpg": "6058",
	"./JOBS.jpg": "fda0",
	"./LEADWELL.jpg": "fa6e",
	"./MAG.jpg": "a5de",
	"./MAG1.jpg": "e256",
	"./MAG2.jpg": "c053",
	"./MAG3.jpg": "9ae8",
	"./MAG4.jpg": "b897",
	"./MAG5.jpg": "2743",
	"./MAG6.jpg": "1846",
	"./MORARA.jpg": "451f4",
	"./Modul.jpg": "9a25",
	"./Pfiffner.jpg": "c592",
	"./Pfiffner1.jpg": "494e",
	"./Pfiffner2.jpg": "6656",
	"./Rambaudi.jpg": "688e",
	"./SEC.jpg": "b498",
	"./SMS.jpg": "ed0b",
	"./SNK1.jpg": "2688",
	"./SNK2.jpg": "73ed",
	"./Sachman.jpg": "fd6d",
	"./TACCHELLA.jpg": "356e",
	"./TAKAMAZ.jpg": "1674",
	"./Takeuchi.jpg": "9da5",
	"./VDF.jpg": "9c45",
	"./WAIDA.jpg": "4bf3",
	"./feeler.jpg": "06ca",
	"./mectron.jpg": "2c95",
	"./taisei.jpg": "0542"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a0a";